export default __webpack_public_path__ + "static/002-b1e408fc5fc681831079a30e4d602583.jpg";